/* eslint-disable */
import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import styles from './softwareAndHardwareCost.module.scss';
import NoDataFound from '../../../../../Assets/images/svg/dar_no_new_file.svg';
import MagnifyingGlass from '../../../../../Assets/images/svg/dar_magnifying.svg';
import { v4 as uuidv4 } from 'uuid';
import EditIcon from '../../../../../Assets/images/svg/dar_pencil.svg';
import DeleteIcon from '../../../../../Assets/images/svg/dar_delete.svg';
import DataGridComponent from '../../Efforts/scopeDataGrid';
import AddIcon from '@mui/icons-material/Add';
import SearchDropdown from '../../../../../Components/Dropdown/dropdown';
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import { AuthContext } from '../../../../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../../../../Constants/modules';
import UseAxios from '../../../../../Api/http/http';
import {
  deleteSoftwareHardware,
  editSoftwareHardware,
  getHardwareData,
  getSoftwareData,
  saveSoftwareHardware,
} from '../../../../../Api/request/dealFinancial';
import {
  getHardwareCost,
  getSoftwareCost,
} from '../../../../../Api/request/costMaster';
import { useLocation } from 'react-router-dom';
import SummaryContainer from './summaryContainer';
import { useSnackbar } from '../../../../../Components/Snackbar/snackBarProvider';

const SoftwareAndHardwareCost = () => {
  const { snackbarOpen } = useSnackbar();
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  const DEAL_ID = query.get('id');
  const { userProfile } = useContext(AuthContext);
  const permission = userProfile?.permissions
    ? userProfile.permissions[
        MODULE_NAMES.DEAL_TRANSITION_DETAIL_COMMERCIALS
      ] || []
    : [];

  const hasAccess = (action) => {
    return permission.includes(action);
  };

  const [softwareList, setSoftwareList] = useState([]);
  const [hardwareList, setHardwareList] = useState([]);
  const [softwareSearchQuery, setSoftwareSearchQuery] = useState('');
  const [hardwareSearchQuery, setHardwareSearchQuery] = useState('');
  const [isMobileView, setIsMobileView] = useState(false);

  const handleUnitsChange = (id, type, value) => {
    const setRowsFunction =
      type === 'Software' ? setSoftwareData : setHardwareData;

    setRowsFunction((prevRows) =>
      prevRows.map((row) =>
        row.id === id
          ? {
              ...row,
              requiredUnits: parseInt(value, 10) || 0,
            }
          : row
      )
    );
  };
  const createSrNoColumn = () => ({
    field: 'srNo',
    headerName: 'Sr.No.',
    sortable: false,
    width: isMobileView ? 90 : 0,
    flex: !isMobileView ? 0.7 : 0,
    disableColumnMenu: true,
    cellClassName: styles['text-center'],
  });

  const ActionButtons = ({ isMobileView, params, param }) => (
    <div
      style={{
        marginTop: 10,
        display: 'flex',
        gap: '10px',
        justifyContent: isMobileView ? 'flex-end' : 'start',
        paddingRight: isMobileView ? '40px' : '0',
      }}
    >
      <button
        className={styles['save-button']}
        onClick={() => handleSave(params.row.id, param)}
        disabled={isRowUnchanged(params.row)}
      >
        <DoneIcon sx={{ color: 'white' }} />
      </button>
      <button
        className={styles['cancel-button']}
        onClick={() => handleCancel(params.row.id, param)}
      >
        <ClearIcon sx={{ color: '#6B5CE8' }} />
      </button>
    </div>
  );

  ActionButtons.propTypes = {
    isMobileView: PropTypes.bool.isRequired,
    params: PropTypes.shape({
      row: PropTypes.object.isRequired,
    }).isRequired,
    param: PropTypes.string.isRequired,
  };

  const createResourceColumn = (param) => ({
    field: param.toLowerCase(),
    headerName: param === 'Software' ? 'Software' : 'Hardware',
    sortable: false,
    width: isMobileView ? 150 : 0,
    flex: !isMobileView ? 1.5 : 0,
    disableColumnMenu: true,
    renderCell: (params) =>
      params.row.isEditing ? (
        <div>
          <SearchDropdown
            placeholder="Select"
            options={
              param === 'Software'
                ? softwareList.map((option) => ({
                    name: option.software,
                    id: option.id,
                    cost: option.cost,
                    currency: option.currency,
                  }))
                : hardwareList.map((option) => ({
                    name: option.hardware,
                    id: option.id,
                    cost: option.cost,
                    currency: option.currency,
                  }))
            }
            onChange={(e) => handleInputChange(e, params.row.id, param)}
            value={params.row.resource}
            dropdownCss={styles['dropdown-css']}
            searchBox={false}
          />
          {/* {isMobileView && (
            <ActionButtons
              isMobileView={isMobileView}
              params={params}
              param={param}
            />
          )} */}
        </div>
      ) : (
        <label className="saved-value">{params.row.resource}</label>
      ),
  });

  const createCostColumn = (param) => ({
    field: 'licenceSoftwareCost',
    headerName:
      param === 'Software'
        ? 'Licence / Software Cost'
        : 'Licence / Hardware Cost',
    sortable: false,
    width: isMobileView ? 250 : 0,
    flex: !isMobileView ? 1.5 : 0,
    disableColumnMenu: true,
    headerClassName: styles.headerRight,
    renderCell: (params) => (
      <div
        style={{
          display: 'flex',
          marginTop: '0.8rem',
          lineHeight: '1rem',
          flexDirection: 'column',
          textAlign: 'right',
          paddingRight: '40px',
        }}
      >
        <span>
          {params.row.perUnitCost ? `${params.row.currency ==='INR'?'₹':'$'}${params.row.perUnitCost}` : ''}
        </span>
        <span className={styles['per-year']}>{params.row.unit || ''}</span>
      </div>
    ),
  });

  const createUnitsColumn = (param) => ({
    field: 'reqdUnits',
    headerName: 'Required Units',
    sortable: false,
    width: isMobileView ? 150 : 0,
    flex: !isMobileView ? 1 : 0,
    disableColumnMenu: true,
    renderCell: (params) =>
      params.row.isEditing ? (
        <div className={styles.counterDiv}>
          <button
            onClick={() =>
              handleDecrement(params.row.id, 'requiredUnits', param)
            }
          >
            –
          </button>
          <input
            value={params.row.requiredUnits}
            style={{ height: '28px' }}
            onChange={(e) =>
              handleUnitsChange(params.row.id, 'Software', e.target.value)
            }
          />
          <button
            onClick={() =>
              handleIncrement(params.row.id, 'requiredUnits', param)
            }
          >
            +
          </button>
        </div>
      ) : (
        <label style={{ display: 'flex' }}>
          {params.row.id === '' ? '' : params.row.requiredUnits}
        </label>
      ),
  });

  const createDurationColumn = (param) => ({
    field: 'reqdDuration',
    headerName: 'Required Duration',
    sortable: false,
    width: isMobileView ? 150 : 0,
    flex: !isMobileView ? 0.8 : 0,
    disableColumnMenu: true,
    renderCell: (params) =>
      params.row.isEditing ? (
        <div style={{ display: 'flex', alignItems:'center' }}>
          <input
            value={params.row.duration}
            onChange={(e) => handleDurationChange(e, params.row.id, param)}
            className={styles.currencyInput}
          />
          <div style={{ marginLeft: '8px' }}>Month/s</div>
        </div>
      ) : (
        <div
          className="saved-value"
          style={{ display: 'flex', flexDirection: 'row', alignItems:'center' }}
        >
          {params.row.duration}
          <div style={{ marginLeft: '8px' }}>Month/s</div>
        </div>
      ),
  });

  const createTotalCostColumn = (param) => ({
    field: 'totalCost',
    headerName: 'Total Cost',
    sortable: false,
    width: isMobileView ? 150 : 0,
    flex: !isMobileView ? 1 : 0,
    disableColumnMenu: true,
    headerAlign: 'right',
    headerClassName: styles.headerRight,
    renderCell: (params) =>
      params.row.isEditing ? (
        <div>
          <p className={styles['total-cost']} style={{ paddingRight: '40px' }}>
            {params.row.cost ? `${params.row.currency ==='INR'?'₹':'$'}${params.row.cost}` : params.row.cost}
          </p>
        </div>
      ) : (
        <p
          className={styles['total-cost']}
          style={{ paddingRight: '40px' }}
        >{`${params.row.currency ==='INR'?'₹':'$'}${params.row.cost}`}</p>
      ),
  });

  const createActionColumn = (param) => ({
    sortable: false,
    width: isMobileView ? 100 : 0,
    flex: !isMobileView ? 0.5 : 0,
    headerClassName: styles.actionColumn,
    cellClassName: styles.actionCell,
    disableColumnMenu: true,
    renderCell: (params) =>
      params.row.id === '' || params.row.isEditing ? (
        <div className={styles['save-and-cancel-button-main']} style={{ paddingTop: '0px' }}>
        <button
          className={styles['save-and-cancel-button'] + ' ' + styles['save-button-tick-placing']}
          style={{
            backgroundColor: '#6B5CE8',
            color: '#ffff',
          }}
          onClick={() => handleSave(params.row.id, param)}
          disabled={isRowUnchanged(params.row)}
        >✔</button>
        <button
          className={styles['save-and-cancel-button'] + ' ' + styles['save-button-cross-placing']}
          style={{
            backgroundColor: 'transparent',
            color: '#6B5CE8',
            border: '1px solid #6B5CE8'
          }}
          onClick={() => handleCancel(params.row.id, param)}
        >X</button>
      </div>
      ) : (
        <div className="action-icons">
          <button
            className="role-action-edit-icon"
            aria-label="Edit"
            style={{
              background: 'none',
              border: 'none',
              cursor: hasAccess('update') ? 'pointer' : 'not-allowed',
              opacity: hasAccess('update') ? 1 : 0.5,
              padding: 0,
            }}
            onClick={() => handleEdit(params.row.id, param)}
            disabled={!hasAccess('update')}
          >
            <img src={EditIcon} alt="Edit" />
          </button>
          <button
            className="role-action-edit-icon"
            aria-label="Delete"
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              marginLeft: '12px',
              cursor: hasAccess('delete') ? 'pointer' : 'not-allowed',
              opacity: hasAccess('delete') ? 1 : 0.5,
            }}
            disabled={!hasAccess('delete')}
            onClick={() => handleDelete(params.row.id, param)}
          >
            <img src={DeleteIcon} alt="Delete" />
          </button>
        </div>
      ),
  });

  const columns = (param) => [
    createSrNoColumn(),
    createResourceColumn(param),
    createCostColumn(param),
    createUnitsColumn(param),
    createDurationColumn(param),
    createTotalCostColumn(param),
    createActionColumn(param),
  ];

  const newRowTemplate = {
    costId: '',
    requiredUnits: '',
    duration: '',
  };

  const isRowUnchanged = (row) => {
    return Object.keys(newRowTemplate).some(
      (key) => row[key] === newRowTemplate[key]
    );
  };

  const handleAddRow = (type) => {
    const newRow = {
      id: uuidv4(),
      srNo: 1,
      name: '',
      cost: '',
      costId: '',
      requiredUnits: 1,
      duration: 1,
      totalCost: '',
      isEditing: true,
      isSaved: false,
      addFlag: true,
      ...(type === 'Software'
        ? { software: '', licenceSoftwareCost: '' }
        : { hardware: '', hardwareCost: '' }),
    };

    const setRowsFunction =
      type === 'Software' ? setSoftwareData : setHardwareData;

    setRowsFunction((prevRows) => {
      const updatedRows = [newRow, ...prevRows].map((row, index) => ({
        ...row,
        srNo: index + 1,
      }));
      return updatedRows;
    });
  };

  const handleEdit = (id, type) => {
    const setRowsFunction =
      type === 'Software' ? setSoftwareData : setHardwareData;

    setRowsFunction((prevRows) =>
      prevRows.map((row) =>
        row.id === id
          ? {
              ...row,
              isEditing: true,
              addFlag: false,
              originalData: { ...row },
            }
          : row
      )
    );
  };

  const handleInputChange = (e, id, type) => {
    const setRowsFunction =
      type === 'Software' ? setSoftwareData : setHardwareData;
    const value = e.target.value;
    setRowsFunction((prevRows) =>
      prevRows.map((row) =>
        row.id === id
          ? {
              ...row,
              costId: value.id,
              resource: value.name,
              perUnitCost: value.cost,
              currency: value.currency,
            }
          : row
      )
    );
  };

  const handleDurationChange = (e, id, field) => {
    const setRowsFunction =
      field === 'Software' ? setSoftwareData : setHardwareData;
    const value = Number(e.target.value);
    setRowsFunction((prevRows) =>
      prevRows.map((row) => (row.id === id ? { ...row, duration: value } : row))
    );
  };

  const handleIncrement = (id, field, type) => {
    const setRowsFunction =
      type === 'Software' ? setSoftwareData : setHardwareData;
    setRowsFunction((prevRows) =>
      prevRows.map((row) =>
        row.id === id ? { ...row, [field]: row[field] + 1 } : row
      )
    );
  };

  const handleDecrement = (id, field, type) => {
    const setRowsFunction =
      type === 'Software' ? setSoftwareData : setHardwareData;
    setRowsFunction((prevRows) =>
      prevRows.map((row) =>
        row.id === id ? { ...row, [field]: row[field] - 1 } : row
      )
    );
  };

  const handleCancel = (id, type) => {
    const setRowsFunction =
      type === 'Software' ? setSoftwareData : setHardwareData;
    setRowsFunction((prevRows) => {
      const updatedRows = prevRows
        .filter((row) => row.isSaved !== false || row.id !== id)
        .map((row) =>
          row.id === id ? { ...row.originalData, isEditing: false } : row
        );
      return updatedRows.map((row, index) => ({ ...row, srNo: index + 1 }));
    });
  };

  const handleSave = async (id, type) => {
    const {
      setRowsFunction,
      setInsightsFunction,
      setCostFunction,
      getRowFunction,
      fetchFunction,
    } = getFunctionsByType(type);

    const rowToSave = getRowById(getRowFunction, id);
    const payload = createPayload(rowToSave, type);

    try {
      const response = await saveOrEditRow(rowToSave, payload);
      handleResponse(response, rowToSave);
      await updateRows(
        setRowsFunction,
        fetchFunction,
        id,
        setInsightsFunction,
        setCostFunction
      );
    } catch (err) {
      handleError(err);
    }
  };

  const getFunctionsByType = (type) => {
    return {
      setRowsFunction: type === 'Software' ? setSoftwareData : setHardwareData,
      setInsightsFunction:
        type === 'Software' ? setSoftwareInsights : setHardwareInsights,
      setCostFunction:
        type === 'Software' ? setSoftwareTotalCost : setHardwareTotalCost,
      getRowFunction: type === 'Software' ? softwareData : hardwareData,
      fetchFunction:
        type === 'Software'
          ? () => getSoftwareData(DEAL_ID, 1, 10)
          : () => getHardwareData(DEAL_ID, 1, 10),
    };
  };

  const getRowById = (getRowFunction, id) => {
    return getRowFunction.find((row) => row.id === id);
  };

  const handleResponse = (response, rowToSave) => {
    if (response.status === 200) {
      const message = rowToSave.addFlag
        ? 'Data saved successfully'
        : 'Data updated successfully';
      snackbarOpen(message, 'success');
    }
  };

  const handleError = (err) => {
    console.error('Error saving data:', err);
    snackbarOpen('Oops! Please try again', 'warning');
  };

  const createPayload = (rowToSave, type) => ({
    requiredUnits: rowToSave.requiredUnits,
    unitType: 'months',
    duration: rowToSave.duration,
    softwareCostId: type === 'Software' ? rowToSave.costId : null,
    hardwareCostId: type === 'Hardware' ? rowToSave.costId : null,
    staffingCostId: null,
    vendorCostId: null,
    travelCostId: null,
    cloudCostId: null,
  });

  const saveOrEditRow = async (rowToSave, payload) => {
    if (rowToSave.addFlag) {
      return await UseAxios(saveSoftwareHardware(payload, DEAL_ID));
    } else {
      return await UseAxios(editSoftwareHardware(payload, rowToSave.id));
    }
  };

  const updateRows = async (
    setRowsFunction,
    fetchFunction,
    id,
    setInsightsFunction,
    setCostFunction
  ) => {
    try {
      const res = await UseAxios(fetchFunction());
      setInsightsFunction(res.data.data.costStats);
      setCostFunction(res.data.data.totalCost);
      setRowsFunction(
        res.data.data.list.map((row, index) => ({
          ...row,
          srNo: index + 1,
        }))
      );
      setRowsFunction((prevRows) =>
        prevRows.map((row) =>
          row.id === id ? { ...row, isEditing: false, addFlag: false } : row
        )
      );
    } catch (fetchError) {
      console.error('Error fetching data:', fetchError);
    }
  };
  const handleDelete = (id, type) => {
    const deleteRow = async () => {
      try {
        const res = await UseAxios(deleteSoftwareHardware(id));
        if (res.status === 200) {
          if (type === 'Software') {
            try {
              const res = await UseAxios(getSoftwareData(DEAL_ID, 1, 10));
              const resData = res.data.data.list;
              const softwareWithSrNo = resData.map((item, index) => ({
                ...item,
                srNo: index + 1,
              }));
              snackbarOpen('Data deleted successfully', 'success');
              setSoftwareData(softwareWithSrNo);
            } catch (err) {
              snackbarOpen('Oops! Please try again', 'warning');
              console.error('Error fetching data:', err);
            }
          } else {
            try {
              const res = await UseAxios(getHardwareData(DEAL_ID, 1, 10));
              const resData = res.data.data.list;
              const hardwareWithSrNo = resData.map((item, index) => ({
                ...item,
                srNo: index + 1,
              }));
              setHardwareData(hardwareWithSrNo);
            } catch (err) {
              console.error('Error fetching data:', err);
            }
          }
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };
    deleteRow();
  };

  const [softwareData, setSoftwareData] = useState([]);
  const [hardwareData, setHardwareData] = useState([]);
  const [softwareInsights, setSoftwareInsights] = useState([]);
  const [hardwareInsights, setHardwareInsights] = useState([]);
  const [softwareTotalCost, setSoftwareTotalCost] = useState(0);
  const [hardwareTotalCost, setHardwareTotalCost] = useState(0);

  useEffect(() => {
    const fetchSoftwareOption = async () => {
      try {
        const res = await UseAxios(getSoftwareCost());
        const transformedData = res.data.map((item) => ({
          ...item,
          perUnitCost: item.cost,
        }));
        setSoftwareList(transformedData);
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    const fetchHardwareOption = async () => {
      try {
        const res = await UseAxios(getHardwareCost());
        const transformedData = res.data.data.map((item) => ({
          ...item,
          perUnitCost: item.cost,
        }));
        setHardwareList(transformedData);
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };
    fetchSoftwareOption();
    fetchHardwareOption();
  }, [softwareData, hardwareData]);

  useEffect(() => {
    checkMobileView();
    const fetchSoftwareList = async () => {
      try {
        const res = await UseAxios(getSoftwareData(DEAL_ID, 1, 10));
        const resData = res.data.data.list;
        const softwareInsights = res.data.data.costStats;
        const totalSoftwareCost = res.data.data.totalCost;
        const softwareWithSrNo = resData.map((item, index) => ({
          ...item,
          srNo: index + 1,
        }));

        setSoftwareData(softwareWithSrNo);
        setSoftwareInsights(softwareInsights);
        setSoftwareTotalCost(totalSoftwareCost);
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    const fetchHardwareList = async () => {
      try {
        const res = await UseAxios(getHardwareData(DEAL_ID, 1, 10));
        const resData = res.data.data.list;
        const hardwareInsights = res.data.data.costStats;
        const totalHardwareCost = res.data.data.totalCost;
        const hardwareWithSrNo = resData.map((item, index) => ({
          ...item,
          srNo: index + 1,
        }));
        setHardwareData(hardwareWithSrNo);
        setHardwareInsights(hardwareInsights);
        setHardwareTotalCost(totalHardwareCost);
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    fetchSoftwareList();
    fetchHardwareList();

    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, []);
  const filteredSoftwareData = softwareData.filter(
    (item) =>
      !softwareSearchQuery ||
      item.resource?.toLowerCase().includes(softwareSearchQuery.toLowerCase())
  );

  const filteredHardwareData = hardwareData.filter(
    (item) =>
      !hardwareSearchQuery ||
      item.resource?.toLowerCase().includes(hardwareSearchQuery.toLowerCase())
  );

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth <= 1024);
  };

  return (
    <div
      style={{
        display: 'flex',
        gap: '10px',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      <SummaryContainer
        softwareInsights={softwareInsights}
        hardwareInsights={hardwareInsights}
        softwareTotalCost={softwareTotalCost}
        hardwareTotalCost={hardwareTotalCost}
      />
      <div className={styles.travelCostGrid}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '0px 10px',
            flexDirection: window.innerWidth <= 768 ? 'column' : 'row',
          }}
        >
          <div className={styles['title']}>Software Cost</div>
          <div
            style={{
              justifyContent: 'space-between',
              display: 'flex',
              gap: '10px',
            }}
          >
            <div className={styles['certification-search']}>
              <img src={MagnifyingGlass} alt="Search" />
              <input
                id="certification-search-input"
                type="text"
                placeholder="Search..."
                style={{ height: '28px' }}
                onChange={(e) => setSoftwareSearchQuery(e.target.value)}
              />
            </div>
            <button
              className={styles['button-add']}
              onClick={() => handleAddRow('Software')}
              disabled={!hasAccess('create')}
            >
              <AddIcon sx={{ fontSize: 20 }} />
              Add
            </button>
          </div>
        </div>
        <DataGridComponent
          dataRows={filteredSoftwareData}
          dataColumns={columns('Software')}
          isEdit={setSoftwareData}
          pageSize={10}
          sortFilterColumns={[]}
          onRowSelectionChange={() => {}}
          checkboxDisabled={false}
          rowHeight={150}
          noDataImage={NoDataFound}
          noDataTitle="No Software added yet."
          noDataSubTitle="Please add it to view here"
          hideSeparator={true}
          editStateHeight={110}
          dataGridCss={styles.dataGrid}
        />
      </div>
      <div className={styles.travelCostGrid}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '0px 10px',
            flexDirection: window.innerWidth <= 768 ? 'column' : 'row',
          }}
        >
          <div className={styles['title']}>Hardware Cost</div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: '10px',
            }}
          >
            <div className={styles['certification-search']}>
              <img src={MagnifyingGlass} alt="Search" />
              <input
                id="certification-search-input"
                type="text"
                placeholder="Search..."
                style={{ height: '28px' }}
                onChange={(e) => setHardwareSearchQuery(e.target.value)}
              />
            </div>
            <button
              className={styles['button-add']}
              onClick={() => handleAddRow('Hardware')}
              disabled={!hasAccess('create')}
            >
              <AddIcon sx={{ fontSize: 20 }} />
              Add
            </button>
          </div>
        </div>
        <DataGridComponent
          dataRows={filteredHardwareData}
          dataColumns={columns('Hardware')}
          pageSize={10}
          isEdit={setHardwareData}
          sortFilterColumns={[]}
          onRowSelectionChange={() => {}}
          checkboxDisabled={false}
          rowHeight={150}
          noDataImage={NoDataFound}
          noDataTitle="No Hardware added yet."
          noDataSubTitle="Please add it to view here"
          hideSeparator={true}
          editStateHeight={110}
          dataGridCss={styles.dataGrid}
        />
      </div>
    </div>
  );
};

export default SoftwareAndHardwareCost;
